import {asyncRoutes, constantRoutes} from '@/base/router'
import {filterAsyncRoutes} from '@/common/permission'

const state = {
  routes: [],
  addRoutes: []
}

const mutations = {
  SET_ROUTES: (state, routes) => {
    state.addRoutes = routes
    state.routes = constantRoutes.concat(routes)
  }
}

const actions = {
  generateRoutes({commit}, permissions) {
    return new Promise(resolve => {
      let accessedRoutes
      // console.log('permissions:' + JSON.stringify(permissions))
      accessedRoutes = filterAsyncRoutes(asyncRoutes, permissions)
      // console.log('accessedRoutes:' + JSON.stringify(accessedRoutes))
      commit('SET_ROUTES', accessedRoutes)
      resolve(accessedRoutes)
    })
  }
}

export default {
  namespaced: true,
  state,
  mutations,
  actions
}



// WEBPACK FOOTER //
// ./src/vuex/modules/permission.js